import BellIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/BellIconPath";
import BellStrikethroughIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/BellStrikethroughIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import styles from "./notification.module.css";

type NotificationsInboxIconProps = {
  unreadCount: number;
  hasNotificationsData: boolean;
  ariaLabel: string;
  onClick: () => void;
};

export const NotificationsInboxIcon = ({
  unreadCount,
  hasNotificationsData,
  ariaLabel,
  onClick,
}: NotificationsInboxIconProps) => {
  const showUnreadBadge = unreadCount > 0 && hasNotificationsData;
  const unreadBadgeLabel = unreadCount > 99 ? "99+" : String(unreadCount);
  const badgeCharCount = unreadBadgeLabel.length;
  const isPillBadge = badgeCharCount > 1;
  const pillSizeClass =
    isPillBadge && badgeCharCount >= 3
      ? (styles["notification-inbox-unread-badge--pill-3"] ?? "")
      : "";

  const bellIcon = !hasNotificationsData
    ? BellStrikethroughIconPath
    : BellIconPath;

  return (
    <div className={styles["notification-inbox-button-wrapper"] ?? ""}>
      <FixaButton
        aria-label={ariaLabel}
        data-testid="notification inbox button"
        type="tertiary"
        inverseTheme
        onClick={onClick}
        iconOnly
        ssrIcon={bellIcon}
      />
      {showUnreadBadge && (
        <span
          className={[
            styles["notification-inbox-unread-badge"] ?? "",
            isPillBadge
              ? (styles["notification-inbox-unread-badge--pill"] ?? "")
              : "",
            pillSizeClass,
          ]
            .filter(Boolean)
            .join(" ")}
          aria-hidden="true"
          data-testid="notification inbox unread badge"
        >
          {unreadBadgeLabel}
        </span>
      )}
    </div>
  );
};
